import {
  faDashboard,
  faServer,
  faExclamationTriangle,
  faCodePullRequest,
  faFileInvoice,
  faGear,
  faMessage,
  faLightbulb,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { Location } from "react-router-dom";
import BillSummary from "../pages/billing/currentBill/CurrentBill";
import AddExtraData from "../pages/dashboard/addExtraData/AddExtraData";
import DetailedReport from "../pages/dashboard/detailedReport/DetailedReport";
import BroadbandReport from "../pages/dashboard/protocolReport/broadbandReport/BroadbandReport";
import ProtocolReport from "../pages/dashboard/protocolReport/ProtocolReport";
import PurchaseHistory from "../pages/dashboard/purchaseHistory/PurchaseHistory";
import RedeemData from "../pages/dashboard/redeemData/RedeemData";
import UsageSummery from "../pages/dashboard/usageSummery/UsageSummery";
import IntelligenceSolution from "../pages/intelligenceSolution/IntelligenceSolution";
import IntelligenceSolutionItem from "../pages/intelligenceSolution/intelligenceSolutionItem/IntelligenceSolutionItem";
import FaultList from "../pages/myFaults/faultList/FaultList";
import FaultStatus from "../pages/myFaults/faultStatus/FaultStatus";
import ReportFault from "../pages/myFaults/reportFault/ReportFault";
import RfoRequest from "../pages/myFaults/rfoRequest/RfoRequest";
import AddUser from "../pages/settings/users/addUser/AddUser";
import AssignPrivilege from "../pages/settings/users/assignPrivilege/AssignPrivilege";
import Users from "../pages/settings/users/Users";
import PRIVILEGES from "./privilegesList";
import AssignCircuitGroup from "../pages/settings/users/assignCircuitGroup/AssignCircuitGroup";
import BillHistory from "../pages/billing/billHistory/BillHistory";
import ChangePortalPassword from "../pages/settings/users/changePortalPassword/changePortalPassword";
import PaymentSummary from "../pages/billing/paymentSummary/PaymentSummary";
import CurrentBill from "../pages/billing/currentBill/CurrentBill";
import FaultProgress from "../pages/statusTracker/faultStatus/FaultProgress";
import BillComplaintProgress from "../pages/statusTracker/billComplaintStatus/BillComplaintProgress";
import DataAddon from "../pages/serviceRequest/dataAddons/DataAddOns";
import ServiceRequest from "../pages/serviceRequest/newService/ServiceRequest";
import ServiceRelocation from "../pages/serviceRequest/serviceRelocation/ServiceRelocation";
import AddToFavourites from "../pages/settings/users/addToFavourites/addToFavourites";
import OrderProgress from "../pages/statusTracker/orderStatus/OrderProgress";
import AssignAccountGroup from "../pages/settings/users/assignAccountGroup/AssignAccountGroup";
import Messages from "../pages/messages/messages";
import GroupChat from "../pages/messages/message_thred";
import Notifications from "../pages/notifications/notifications";
import ServiceRequestHistory from "../pages/serviceRequest/serviceRequestHistory/ServiceRequestHistory";
import ServiceLineUpPage from "../pages/serviceLineUp/ServiceLineUp";
import Promo from "../pages/serviceLineUp/Promo";
import ServiceRequestProgress from "../pages/statusTracker/serviceRequest/ServiceRequestProgress";
import ServicesTable from "../pages/serviceLineUp/detailTable/servicesTable";
import ServiceModification from "../pages/serviceRequest/serviceModification/ServiceModification";
import BillMode from "../pages/billing/billMode/BillMode";
import OngoingFaultList from "../pages/statusTracker/faultStatus/FaultList";
import OngoingBillComplainList from "../pages/statusTracker/billComplaintStatus/BillComplainList";
import OngoingOrderComplainList from "../pages/statusTracker/orderStatus/OrderComplainList";
import UserGuide from "../pages/settings/userGuide/UserGuide";

export interface IRouteItemProps {
  title: string;
  path: string;
  id?: string;
  route: string;
  element: ReactNode;
  isNavBarItem: boolean;
  subItems?: IRouteItemProps[];
}

export enum EBaseRoutes {
  ServiceLineUp = "/serviceLineUp",
  IntelligenceSolution = "/intelligenceSolution",
  Fault = "/fault",
  Billing = "/billing",
  ServiceRequest = "/serviceRequest",
  Dashboard = "/dashboard",
  Messages = "/messages",
  Settings = "/settings",
  Status = "/tracker",
}

const routes = (
  location: Location
): {
  title: string;
  itemId: string;
  elemBefore: () => JSX.Element;
  subItems: IRouteItemProps[];
}[] => [
  {
    title: "Service Line Up",
    itemId: EBaseRoutes.ServiceLineUp,
    elemBefore: () => {
      return (
        <FontAwesomeIcon
          icon={faServer}
          className={[
            "nav-icon ",
            location.pathname.includes(EBaseRoutes.ServiceLineUp) &&
              "nav-icon-selected",
          ].join(" ")}
        />
      );
    },
    subItems: [
      {
        title: "Service Line Up",
        path: "/serviceLineUp",
        route: "serviceLineUp",
        isNavBarItem: true,
        element: <ServiceLineUpPage />,
      },
      {
        title: "Service Line Up Info",
        path: "/serviceLineUp/:productName",
        route: "serviceLineUp/:productName",
        isNavBarItem: false,
        element: <ServicesTable />,
      },
      {
        title: "Usage Summary",
        path: "/serviceLineUp/usageSummery",
        id: PRIVILEGES.USAGE_SUMMARY,
        route: "serviceLineUp/usageSummery",
        isNavBarItem: false,
        element: <UsageSummery />,
      },
      {
        title: "Enable/Disable Protocol Report",
        path: "/serviceLineUp/detailedReport",
        id: PRIVILEGES.DETAILED_REPORT,
        route: "serviceLineUp/detailedReport",
        isNavBarItem: false,
        element: <DetailedReport />,
      },
      {
        title: "Protocol Report",
        path: "/serviceLineUp/protocolReport",
        id: PRIVILEGES.VIEW_PROTOCOL_REPORT,
        route: "serviceLineUp/protocolReport",
        isNavBarItem: false,
        element: <ProtocolReport />,
      },
      {
        title: "Protocol Report Broadband",
        path: "/serviceLineUp/protocolReport/:serviceId/:date",
        id: PRIVILEGES.VIEW_PROTOCOL_REPORT,
        route: "serviceLineUp/protocolReport/:serviceId/:date",
        isNavBarItem: false,
        element: <BroadbandReport />,
      },
      {
        title: "Add Extra GB/Data",
        path: "/serviceLineUp/addExtraData",
        id: PRIVILEGES.ADD_EXTRA_DATA,
        route: "serviceLineUp/addExtraData",
        isNavBarItem: false,
        element: <AddExtraData />,
      },
      {
        title: "Purchase History",
        path: "/serviceLineUp/purchaseHistory",
        id: PRIVILEGES.PURCHASE_HISTORY,
        route: "serviceLineUp/purchaseHistory",
        isNavBarItem: false,
        element: <PurchaseHistory />,
      },
      // {
      //   title: 'Change Contact Details',
      //   path: '/dashboard/changeContactDetails',
      //   id: PRIVILEGES.CHANGE_CONTACT,
      //   route: 'dashboard/changeContactDetails',
      //   isNavBarItem: true,
      //   element: <ChangeContact />,
      // },
      {
        title: "Redeem Data",
        path: "/serviceLineUp/redeemData",
        id: PRIVILEGES.REDEEM_DATA,
        route: "serviceLineUp/redeemData",
        isNavBarItem: false,
        element: <RedeemData />,
      },
      {
        title: "Redeem Voucher",
        path: "/promo",
        route: "promo",
        isNavBarItem: false,
        element: <Promo />,
      },
    ],
  },
  {
    title: "Intelligent Solutions",
    itemId: EBaseRoutes.IntelligenceSolution,
    elemBefore: () => {
      return (
        <FontAwesomeIcon
          icon={faLightbulb}
          className={[
            "nav-icon ",
            location.pathname.includes(EBaseRoutes.IntelligenceSolution) &&
              "nav-icon-selected",
          ].join(" ")}
        />
      );
    },
    subItems: [
      {
        title: "Enterprise",
        path: "/intelligenceSolution/enterprise",
        route: "intelligenceSolution/:type",
        isNavBarItem: true,
        element: <IntelligenceSolution />,
      },
      {
        title: "SME",
        path: "/intelligenceSolution/sme",
        route: "intelligenceSolution/:type",
        isNavBarItem: true,
        element: <IntelligenceSolution />,
      },
      {
        title: "Global Business",
        path: "/intelligenceSolution/globalBusiness",
        route: "intelligenceSolution/:type",
        isNavBarItem: false,
        element: <IntelligenceSolution />,
      },
      {
        title: "SME",
        path: "/intelligenceSolution/sme",
        route: "intelligenceSolution/:type/:itemName",
        isNavBarItem: false,
        element: <IntelligenceSolutionItem />,
      },
    ],
  },

  {
    title: "Complaints",
    itemId: EBaseRoutes.Fault,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.Fault) && "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "Make a Complaint",
        path: "/fault/report",
        id: PRIVILEGES.CREATE_FAULT,
        route: "fault/report",
        isNavBarItem: true,
        element: <ReportFault />,
      },
      {
        title: "Complaint Records",
        path: "/fault/status/faultHistory",
        id: PRIVILEGES.FAULT_STATUS,
        route: "fault/status/faultHistory",
        isNavBarItem: true,
        element: <FaultList />,
      },
      {
        title: "Complaint Status",
        path: "/fault/status/faultStatus",
        id: PRIVILEGES.FAULT_STATUS,
        route: "fault/status/faultStatus",
        isNavBarItem: false,
        element: <FaultStatus />,
      },
      {
        title: "RFO Request",
        path: "/fault/rfo",
        id: PRIVILEGES.RFO_REQUEST,
        route: "fault/rfo",
        isNavBarItem: true,
        element: <RfoRequest />,
      },
      // {
      //   title: 'RFO Status',
      //   path: '/fault/rfoStatus',
      //   id: PRIVILEGES.RFO_STATUS,
      //   route: 'fault/rfoStatus',
      //   isNavBarItem: true,
      //   element: <RfoStatus />,
      // },
    ],
  },
  {
    title: "Status Tracker",
    itemId: EBaseRoutes.Status,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faListCheck}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.Status) && "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "Service Complaint",
        path: "/tracker/status/faultProgress",
        id: PRIVILEGES.FAULT_STATUS,
        route: "tracker/status/faultProgress",
        isNavBarItem: true,
        element: <FaultProgress />,
      },
      {
        title: "Ongoing Service Complaints",
        path: "/tracker/status/faultProgress/ongoing",
        id: PRIVILEGES.FAULT_STATUS,
        route: "tracker/status/faultProgress/ongoing",
        isNavBarItem: false,
        element: <OngoingFaultList />,
      },
      {
        title: "Bill Complaint",
        path: "/tracker/status/billProgress",
        id: PRIVILEGES.CREATE_BILLING_FAULT,
        route: "tracker/status/billProgress",
        isNavBarItem: true,
        element: <BillComplaintProgress />,
      },
      {
        title: "Ongoing Bill Complaint",
        path: "/tracker/status/billProgress/ongoing",
        id: PRIVILEGES.CREATE_BILLING_FAULT,
        route: "tracker/status/billProgress/ongoing",
        isNavBarItem: false,
        element: <OngoingBillComplainList />,
      },
      {
        title: "Service Request",
        path: "/tracker/status/serviceRequestProgress",
        id: PRIVILEGES.CREATE_BILLING_FAULT,
        route: "tracker/status/serviceRequestProgress",
        isNavBarItem: true,
        element: <ServiceRequestProgress />,
      },
      {
        title: "Order",
        path: "/tracker/status/orderProgress",
        id: PRIVILEGES.ORDER_STATUS,
        route: "tracker/status/orderProgress",
        isNavBarItem: true,
        element: <OrderProgress />,
      },
      {
        title: "Ongoing Order Complaint",
        path: "/tracker/status/orderProgress/ongoing",
        id: PRIVILEGES.ORDER_STATUS,
        route: "tracker/status/orderProgress/ongoing",
        isNavBarItem: false,
        element: <OngoingOrderComplainList />,
      },
    ],
  },
  {
    title: "Billing",
    itemId: EBaseRoutes.Billing,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faFileInvoice}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.Billing) &&
            "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "Bill Summary",
        path: "/billing/billSummary",
        id: PRIVILEGES.VIEW_CURRENT_BILL,
        route: "billing/billSummary",
        isNavBarItem: true,
        element: <BillSummary />,
      },
      {
        title: "Bill Mode",
        path: "/billing/billMode",
        id: PRIVILEGES.VIEW_CURRENT_BILL,
        route: "billing/billMode",
        isNavBarItem: true,
        element: <BillMode />,
      },
      {
        title: "Bill History",
        path: "/billing/billHistory",
        id: PRIVILEGES.VIEW_BILL_HISTORY,
        route: "billing/billHistory",
        isNavBarItem: true,
        element: <BillHistory />,
      },
      {
        title: "pay Bill",
        path: "/billing/payBill",
        id: PRIVILEGES.VIEW_CURRENT_BILL,
        route: "billing/payBill",
        isNavBarItem: false,
        element: <PaymentSummary />,
      },
    ],
  },
  {
    title: "Service Request",
    itemId: EBaseRoutes.ServiceRequest,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faCodePullRequest}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.ServiceRequest) &&
            "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "New Service",
        path: "/serviceRequest/newService",
        id: PRIVILEGES.REQUEST_NEW_SERVICE,
        route: "serviceRequest/newService",
        isNavBarItem: true,
        element: <ServiceRequest />,
      },

      {
        title: "Data Addon",
        path: "/serviceRequest/dataAddon",
        id: PRIVILEGES.PURCHASE_DATA_ADDON,
        route: "serviceRequest/dataAddon",
        isNavBarItem: true,
        element: <DataAddon />,
      },
      {
        title: "Service Relocation",
        path: "/serviceRequest/serviceRelocation",
        id: PRIVILEGES.RELOCATION,
        route: "serviceRequest/serviceRelocation",
        isNavBarItem: true,
        element: <ServiceRelocation />,
      },
      {
        title: "Service Modification",
        path: "/serviceRequest/serviceModification",
        id: PRIVILEGES.RELOCATION,
        route: "serviceRequest/serviceModification",
        isNavBarItem: true,
        element: <ServiceModification />,
      },
      {
        title: "Service Request History",
        path: "/serviceRequest/newServiceHistory",
        id: PRIVILEGES.SERVICE_REQUEST_HISTORY,
        route: "serviceRequest/newServiceHistory",
        isNavBarItem: true,
        element: <ServiceRequestHistory />,
      },
    ],
  },
  // {
  //   title: "Dashboard",
  //   itemId: EBaseRoutes.Dashboard,

  //   elemBefore: () => (
  //     <FontAwesomeIcon
  //       icon={faDashboard}
  //       className={[
  //         "nav-icon ",
  //         location.pathname.includes(EBaseRoutes.Dashboard) &&
  //           "nav-icon-selected",
  //       ].join(" ")}
  //     />
  //   ),
  //   subItems: [
  //     {
  //       title: "Usage Summary",
  //       path: "/dashboard/usageSummery",
  //       id: PRIVILEGES.USAGE_SUMMARY,
  //       route: "dashboard/usageSummery",
  //       isNavBarItem: true,
  //       element: <UsageSummery />,
  //     },
  //     {
  //       title: "Enable/Disable Protocol Report",
  //       path: "/dashboard/detailedReport",
  //       id: PRIVILEGES.DETAILED_REPORT,
  //       route: "dashboard/detailedReport",
  //       isNavBarItem: true,
  //       element: <DetailedReport />,
  //     },
  //     {
  //       title: "Protocol Report",
  //       path: "/dashboard/protocolReport",
  //       id: PRIVILEGES.VIEW_PROTOCOL_REPORT,
  //       route: "dashboard/protocolReport",
  //       isNavBarItem: true,
  //       element: <ProtocolReport />,
  //     },
  //     {
  //       title: "Protocol Report Broadband",
  //       path: "/dashboard/protocolReport/:serviceId/:date",
  //       id: PRIVILEGES.VIEW_PROTOCOL_REPORT,
  //       route: "dashboard/protocolReport/:serviceId/:date",
  //       isNavBarItem: true,
  //       element: <BroadbandReport />,
  //     },
  //     {
  //       title: "Add Extra GB/Data",
  //       path: "/dashboard/addExtraData",
  //       id: PRIVILEGES.ADD_EXTRA_DATA,
  //       route: "dashboard/addExtraData",
  //       isNavBarItem: true,
  //       element: <AddExtraData />,
  //     },
  //     {
  //       title: "Purchase History",
  //       path: "/dashboard/purchaseHistory",
  //       id: PRIVILEGES.PURCHASE_HISTORY,
  //       route: "dashboard/purchaseHistory",
  //       isNavBarItem: true,
  //       element: <PurchaseHistory />,
  //     },
  //     // {
  //     //   title: 'Change Contact Details',
  //     //   path: '/dashboard/changeContactDetails',
  //     //   id: PRIVILEGES.CHANGE_CONTACT,
  //     //   route: 'dashboard/changeContactDetails',
  //     //   isNavBarItem: true,
  //     //   element: <ChangeContact />,
  //     // },
  //     {
  //       title: "Redeem Data",
  //       path: "/dashboard/redeemData",
  //       id: PRIVILEGES.REDEEM_DATA,
  //       route: "dashboard/redeemData",
  //       isNavBarItem: true,
  //       element: <RedeemData />,
  //     },
  //   ],
  // },
  {
    title: "Messages",
    itemId: EBaseRoutes.Messages,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faMessage}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.Settings) &&
            "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "Inbox",
        path: "/messages/inbox",
        id: PRIVILEGES.VIEW_INBOX,
        route: "messages/inbox",
        isNavBarItem: true,
        element: <Messages />,
      },
      {
        title: "Inbox",
        path: "/messages/inbox/chat",
        id: PRIVILEGES.VIEW_INBOX,
        route: "messages/inbox/:conversationID",
        isNavBarItem: false,
        element: <GroupChat />,
      },
      {
        title: "Notifications",
        path: "/messages/notifications",
        id: PRIVILEGES.VIEW_NOTIFICATION,
        route: "messages/notifications",
        isNavBarItem: true,
        element: <Notifications />,
      },
    ],
  },
  {
    title: "Settings",
    itemId: EBaseRoutes.Settings,
    elemBefore: () => (
      <FontAwesomeIcon
        icon={faGear}
        className={[
          "nav-icon ",
          location.pathname.includes(EBaseRoutes.Settings) &&
            "nav-icon-selected",
        ].join(" ")}
      />
    ),
    subItems: [
      {
        title: "Manage Users",
        path: "/settings/users",
        id: PRIVILEGES.VIEW_USER,
        route: "settings/users",
        isNavBarItem: true,
        element: <Users />,
      },
      {
        title: "Add Users",
        path: "/settings/users/add",
        id: PRIVILEGES.ADD_USER,
        route: "settings/users/add",
        isNavBarItem: false,
        element: <AddUser />,
      },
      {
        title: "Change Portal Password",
        path: "/settings/changePortalPassword",
        id: PRIVILEGES.CHANGE_PASSWORD,
        route: "/settings/changePortalPassword",
        isNavBarItem: true,
        element: <ChangePortalPassword />,
      },
      {
        title: "Update User",
        path: "/settings/users/add",
        id: PRIVILEGES.UPDATE_EXTERNAL_USER,
        route: "settings/users/:userId/update",
        isNavBarItem: false,
        element: <AddUser />,
      },
      {
        title: "Mange Privileges",
        path: "/settings/users/add",
        id: PRIVILEGES.ASSIGN_PRIVILEGE,
        route: "settings/users/addPrivilege/:userId/:roleId",
        isNavBarItem: false,
        element: <AssignPrivilege />,
      },
      {
        title: "Add to Favourites",
        path: "/settings/addToFavourites",
        id: PRIVILEGES.ASSIGN_PRIVILEGE,
        route: "settings/addToFavourites",
        isNavBarItem: true,
        element: <AddToFavourites />,
      },
      {
        title: "Assign Circuit Group",
        path: "/settings/users/add",
        id: PRIVILEGES.ASSIGN_PRIVILEGE,
        route: "settings/users/assignCircuitGroup/:userId/:name",
        isNavBarItem: false,
        element: <AssignCircuitGroup />,
      },
      {
        title: "Assign Account Group",
        path: "/settings/users/add",
        id: PRIVILEGES.ASSIGN_ACCOUNTS,
        route: "settings/users/assignAccountGroup/:userId/:name",
        isNavBarItem: false,
        element: <AssignAccountGroup />,
      },
      {
        title: "User Guide",
        path: "/settings/userGuide",
        route: "settings/userGuide",
        isNavBarItem: true,
        element: <UserGuide />,
      },
    ],
  },
];

export default routes;
